import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for managing A/B Test Groups (F-026).
 * Provides CRUD operations for test group definitions.
 */
@Injectable({
    providedIn: 'root'
})
export class ABTestGroupService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/abTestGroups')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-flask-vial';
    }
}
